import { Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";
import { MCO_UNDERLYING_COVERAGE_LEVELS } from "api-toolkit/mco/mcoSupplementGrid";
import { formatPercentage } from "utility/formatters";

/** Step 2 for supplement-only Add Plan — intended underlying MPCI coverage (not priced until SCD). */
export default function McoUnderlyingCoverageStep({ basePlanName, selectedCoverage, onSelectCoverage }) {
  return (
    <>
      <Typography sx={{ mb: 1 }}>
        Select the coverage level you intend for your underlying {basePlanName || "MPCI"} policy when it comes on
        sale:
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 2 }}>
        Only MCO can be added now. Your underlying policy is elected separately at its sales closing date — this
        selection is for planning context only and is not saved as a plan.
      </Typography>
      <Grid container spacing={1}>
        {MCO_UNDERLYING_COVERAGE_LEVELS.map((level) => (
          <Grid item xs={6} sm={4} lg={3} key={level}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedCoverage === level}
                  onChange={() => onSelectCoverage(level)}
                />
              }
              label={formatPercentage(level, 0)}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
}
